import dayjs from 'dayjs'

export const configFun = that => {
    const config = {
        searchList: {
            searchTxt: [
                {
                    name: '合同编码',
                    value: 'contractCode',
                    type: 'advance',
                    advanceCode: 'contractCode',
                    tableConfig: [
                        { prop: 'contractCode', value: '合同编码' },
                        { prop: 'contractName', value: '合同名称' },
                    ],
                    advanceUrl: '/contract/popContractInfo',
                    unfold: true,
                    span: 3,
                    cbParams: ['contractCode#contractCode'],
                    prefix: 'api-srm-web',
                },
                {
                    name: '业务类型',
                    value: 'businessType',
                    type: 'select',
                    unfold: true,
                    optionNum: 'BID_BUSINESS_TYPE',
                    span: 3,
                },
                {
                    name: '分公司',
                    value: 'companyName',
                    type: 'advance',
                    advanceConfig: [
                        { prop: 'ALL', value: '全部' },
                        { prop: 'companyCode', value: '分公司代码' },
                        { prop: 'companyNameCn', value: '分公司名称' },
                    ],
                    advanceUrl: '/esCompany/popCompany',
                    tableConfig: [
                        { prop: 'companyCode', value: '分公司编码' },
                        { prop: 'companyNameCn', value: '分公司名称' },
                    ],
                    cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
                    unfold: true,
                    span: 4,
                },
                {
                    name: '服务平台',
                    value: 'siteName',
                    type: 'advance',
                    advanceConfig: [
                        { prop: 'ALL', value: '全部' },
                        { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                        { prop: 'escoCompanyNo', value: '服务平台编码' },
                    ],
                    advanceUrl: '/searchPlatform',
                    advanceCascade: 'companyCode#companyCode',
                    tableConfig: [
                        { prop: 'escoCompanyNo', value: '服务平台编码' },
                        { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    ],
                    cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                    unfold: true,
                    span: 4,
                },
                {
                    name: '供应商名称',
                    value: 'suppliersName',
                    advanceLabel: '供应商弹出框',
                    type: 'advance',
                    advanceConfig: [
                        { prop: 'ALL', value: '全部' },
                        { prop: 'supplierCode', value: '供应商编码' },
                        { prop: 'supplierName', value: '供应商名称' },
                    ],
                    tableConfig: [
                        { prop: 'supplierCode', value: '供应商编码' },
                        { prop: 'supplierName', value: '供应商名称' },
                        { prop: 'supplierTypeName', value: '供应商类型' },
                    ],
                    cbParams: [
                        'supplierCode#supplierCode',
                        'supplierName#suppliersName',
                        // 'supplierType#supplierType',
                        // 'propertyNature#property',
                    ],
                    advanceUrl: '/supplier/getSupplierByServiceType',
                    notFetchOnShow: true,
                    advanceNotSearch: true,
                    queryConditionRequired: true,
                    unfold: true,
                    searchRequired: true,
                    span: 3,
                    advancePrefix: 'api-srm-web',
                    prefix: 'api-srm-web',
                },
                {
                    name: '合同状态',
                    value: 'contractStatus',
                    type: 'select',
                    optionNum: 'SRM_CONTRACT_STATUS',
                    unfold: true,
                    span: 3,
                },
                {
                    name: '完成情况',
                    value: 'completionSchedule',
                    type: 'select',
                    optionNum: 'CONTRACT_WARNING_COMPLETE_TASK',
                    unfold: true,
                    span: 3,
                },
                {
                    name: '合同失效时间',
                    value: 'expDateArr',
                    startPlaceholder: '合同失效开始时间',
                    endPlaceholder: '合同失效结束时间',
                    type: 'time',
                    unfold: true,
                    span: 6,
                },
            ],
            unfoldState: false,
            advancedBtn: false,
        },
        table: {
            tableCut: true,
            clickModify: false,
            selectBtn: true,
            showIndex: true,
            clickState: true,
            height: 400,
            columns: [
                {
                    label: '法务编码',
                    prop: 'legalContractCode',
                    type: 'text',
                    sort: false,
                    disabled: true,
                    require: false,
                    width: 150,
                },
                {
                    label: '合同编码',
                    prop: 'contractCode',
                    sort: false,
                    disabled: true,
                    require: false,
                    width: 150,
                },
                {
                    label: '合同名称',
                    prop: 'contractName',
                    sort: false,
                    disabled: true,
                    require: false,
                    width: 150,
                },
                {
                    label: '业务类型',
                    prop: 'businessTypeText',
                    sort: false,
                    disabled: true,
                    require: false,
                    width: 150,
                },
                {
                    label: '分公司',
                    prop: 'companyName',
                    type: 'advance',
                    advanceCode: 'estimateDrAccountCode',
                    advanceConfig: [
                        { prop: 'flexValue', value: '成本暂估-借方-科目代码' },
                        { prop: 'description', value: '成本暂估-借方-科目名称' },
                    ],
                    advanceUrl: '/efAccountTitle/popAccountTitle',
                    sort: false,
                    disabled: true,
                    require: false,
                    width: 160,
                },
                {
                    label: '服务平台',
                    prop: 'siteName',
                    type: 'advance',
                    advanceCode: 'estimateDrAccountCode',
                    advanceConfig: [
                        { prop: 'flexValue', value: '成本暂估-借方-科目代码' },
                        { prop: 'description', value: '成本暂估-借方-科目名称' },
                    ],
                    advanceUrl: '/efAccountTitle/popAccountTitle',
                    sort: false,
                    disabled: true,
                    require: false,
                    width: 160,
                },
                {
                    label: '供应商名称',
                    prop: 'suppliersName',
                    sort: false,
                    disabled: true,
                    require: false,
                    width: 180,
                },
                {
                    label: '合同状态',
                    prop: '_contractStatus',
                    sort: false,
                    disabled: true,
                    require: false,
                    width: 180,
                },
                {
                    label: '完成情况',
                    prop: 'completionSchedule',
                    type: 'select',
                    optionNum: 'CONTRACT_WARNING_COMPLETE_TASK',
                    sort: false,
                    require: true,
                    max: 5,
                    width: 150,
                },
                {
                    label: '新合同编号/终止原因/其他说明',
                    prop: 'newContractCode',
                    sort: false,
                    require: true,
                    width: 210,
                },
                {
                    label: '失效时间',
                    prop: 'expirationDate',
                    sort: false,
                    disabled: true,
                    width: 150,
                },
                {
                    label: '距离合同到期时间',
                    prop: 'validDay',
                    sort: false,
                    require: false,
                    disabled: true,
                    width: 150,
                },
                {
                    label: 'T30-60需完成事项（固定）',
                    prop: 'type1Text',
                    sort: false,
                    require: false,
                    disabled: true,
                    width: 200,
                },
                {
                    label: 'T10-30需完成事项（固定）',
                    prop: 'type2Text',
                    sort: false,
                    require: false,
                    disabled: true,
                    width: 200,
                },
                {
                    label: 'T-10需完成事项（固定）',
                    prop: 'type3Text',
                    sort: false,
                    require: false,
                    disabled: true,
                    width: 200,
                },
                {
                    label: '待办人',
                    prop: 'sendAccount',
                    sort: false,
                    require: false,
                    disabled: true,
                    width: 150,
                },
            ],
            action: [
                {
                    type: 'text',
                    label: '编辑',
                    size: 'small',
                    event: 'edit',
                    ifHas: '/warningTask-20',
                    show(data) {
                        const { btnPermissions } = that.$store.getters
                        if (btnPermissions.includes('/warningTask-20')) {
                            return true
                        } else {
                            return false
                        }
                    },
                },
                {
                    type: 'text',
                    label: '保存',
                    size: 'small',
                    event: 'save',
                    ifHas: '/warningTask-30',
                    show(data) {
                        const { btnPermissions } = that.$store.getters
                        if (data.edit === 2 && btnPermissions.includes('/warningTask-30')) {
                            return true
                        } else {
                            return false
                        }
                    },
                },
            ],
            leftOperation: true,
            leftWidth: 90,
        },
        page: {
            layout: 'total, sizes, prev, pager, next, jumper',
            pageSize: 10,
            pageNo: 1,
            pageSizes: [10, 30, 50, 100, 200, 500],
        },
    }
    return config
}
